import React, { Component } from 'react'

import '../styles/loader.css'


export default class Loader extends Component{

  render(){

    if(this.props.active === true){
      return(
        <div className="overlay">
          <div className="loader">
          </div>
        </div>
      )
    }else{
      return (null)
    }
  }
}